import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setToken, setUser } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      const token = searchParams.get('token');

      if (!token) {
        navigate('/login?error=authentication_failed');
        return;
      }

      try {
        // Store token
        localStorage.setItem('token', token);

        // Fetch user data
        const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/me`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch user data');
        }

        const data = await response.json();

        // Store user data
        localStorage.setItem('user', JSON.stringify(data.data));

        // Update context
        if (setToken) setToken(token);
        if (setUser) setUser(data.data);

        // Redirect to projects
        navigate('/projects');
      } catch (error) {
        console.error('OAuth callback error:', error);
        navigate('/login?error=authentication_failed');
      }
    };

    handleCallback();
  }, [searchParams, navigate, setToken, setUser]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div className="spinner" style={{
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #3498db',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 1rem'
        }}></div>
        <p>Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
